export const STATUS_LABELS: Record<string, string> = {
  EM_COTACAO: 'Em cotação',
  APROVADO: 'Aprovado',
  PEDIDO_EMITIDO: 'Pedido emitido',
  RECEBIDO: 'Recebido',
}

export const TYPE_LABELS: Record<string, string> = {
  COMPRA_PONTUAL: 'Compra pontual',
  INDUSTRIALIZACAO: 'Industrialização',
}
